import { i18n, inject, observer, pr, React, RouteComponentProps, ui } from "aaa";
import { MessageScreen } from "components/common/MessageScreen";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { SavingsOptionsStore } from "./SavingsOptionsStore";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: SavingsOptionsStore;
}

@inject("externalInterfaceStore")
@observer
export class SavingsOptionsSuccess extends React.Component<IProps & i18n.InjectedIntlProps & RouteComponentProps<{}>, {}> {
    render() {
        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                useWebVersion
                variant="success"
                message={this.props.store.selectedOption ? "capitalSaving" : "smartSavings"} // TODO
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/savingsOptions/SavingsOptionsSuccess.tsx